export var ResetFlags = {
  RESET_NORMAL: 0,
  RESET_REDRAW: 1,
  RESET_RELOAD: 2
};